module.exports = __webpack_public_path__ + "1_0_58/img/loading.a21746f5.gif";